/**
 * ChatTypingDots — three bouncing dots used inside typing/thinking indicators.
 * Shared between the room message lists and the guest twin chat.
 *
 * `inline` renders text-sized dots in the muted text color with a soft
 * staggered fade, for sitting next to a line of text (WhatsApp style).
 */

interface ChatTypingDotsProps {
  variant?: 'bubble' | 'inline'
}

const DOT_DELAYS = ['0ms', '150ms', '300ms']
const INLINE_DOT_DELAYS = ['0ms', '200ms', '400ms']

export function ChatTypingDots(props: ChatTypingDotsProps) {
  const { variant = 'bubble' } = props

  if (variant === 'inline') {
    return (
      <span className="inline-flex items-baseline gap-[3px] text-twin-chat-fg-muted" data-testid="chat-typing-dots-inline">
        {INLINE_DOT_DELAYS.map((delay) => (
          <span
            key={delay}
            className="h-[3px] w-[3px] rounded-full bg-current motion-safe:animate-pulse"
            style={{ animationDelay: delay }}
          />
        ))}
      </span>
    )
  }

  return (
    <div className="flex items-center gap-1.5">
      {DOT_DELAYS.map((delay) => (
        <div
          key={delay}
          className="h-2 w-2 rounded-full bg-twin-chat-fg/60 motion-safe:animate-bounce"
          style={{ animationDelay: delay }}
        />
      ))}
    </div>
  )
}
